import { connect } from 'react-redux'
import HideWhenCampaignActive from '../components/contents_of_campaign/HideWhenCampaignActive'

const mapStateToProps = ({ display }) => ({
  currentContentsDisplays: display.currentContentsDisplays,
  editCampaignActive: display.editCampaignActive,
  isPaymentStatusApproved: display.isPaymentStatusApproved,
})

export default connect(mapStateToProps)(HideWhenCampaignActive)